import {Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {ControlContainer, NgForm, NgModelGroup} from '@angular/forms';
import * as _ from 'lodash';
import {FuncoesUteisService} from 'src/app/services/commons/funcoes-uteis.service';
import {ComboMetaAcao} from "../../../core/combo-meta-acao";
import {MetaAcao} from "../../../core/meta-acao";
import {MetaObjetivo} from "../../../core/metaObjetivo";
import {MetaObjetivoService} from "../../../services/metaObjetivo/meta-objetivo.service";


@Component({
    selector: 'combo-meta-acao',
    templateUrl: './combo-meta-acao.component.html',
    styleUrls: ['./combo-meta-acao.component.css'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm},
        {provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup)}],
})
export class ComboMetaAcaoComponent implements OnInit {

    @Input() showDisplayId;
    @Input() obrigatorio;
    @Input() selecionado;
    @Input() desabilitado;
    @Input() metasAcao: MetaAcao[];
    @Input() idAtividade;

    @Output() valorChange = new EventEmitter();

    dados = [];
    data: any = {};

    constructor(private funcoesUteisService: FuncoesUteisService,
                private metaObjetivoService: MetaObjetivoService) {
    }

    ngOnInit(): void {
        this.data = Date.now();

        setTimeout(() => {
            if (this.metasAcao) {
                this.metasAcao.forEach(meta => {
                    if (meta.metaObjetivo) {
                        const comboMetaAcao = new ComboMetaAcao();
                        comboMetaAcao.id = meta.metaObjetivo.id;
                        comboMetaAcao.descricao = meta.metaObjetivo.codigo + ' - ' + meta.metaObjetivo.descricao;
                        if (this.dados.find(dado => dado.id === comboMetaAcao.id) === undefined)
                            this.dados.push(comboMetaAcao);
                    }
                });
            } else if (this.idAtividade) {
                this.metaObjetivoService.getComboByIdAtividade(this.idAtividade).subscribe((metasAcao: MetaObjetivo[]) => {
                    metasAcao.forEach(meta => {
                        const comboMetaAcao = new ComboMetaAcao();
                        comboMetaAcao.id = meta.id;
                        comboMetaAcao.descricao = meta.descricao;
                        if (this.dados.find(dado => dado.id === comboMetaAcao.id) === undefined)
                            this.dados.push(comboMetaAcao);
                    })
                })
            }

            this.preencherComboMetaAcao();
            this.dados = this.funcoesUteisService.ordernarArray(this.dados, 'descricao');

        }, 0)

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["selecionado"] && this.selecionado && this.selecionado.id) {
            this.preencherComboMetaAcao();
        }
    }

    private preencherComboMetaAcao() {
        if (this.selecionado && this.selecionado.id && this.dados.length) {
            this.selecionado = _.find(this.dados, {id: this.selecionado.id});
        }
    }

    onValorChange(registro: any) {
        this.valorChange.emit(registro);
        this.preencherComboMetaAcao();
    }

}
